// extracted by css-extract-rspack-plugin
export default {"sidebar":"ReposIssuesSidebar-module__sidebar__Wx3El","betaLabel":"ReposIssuesSidebar-module__betaLabel__FbLDQ","divider":"ReposIssuesSidebar-module__divider__Xkpdx"};